export default "__VITE_ASSET__b4XeoFfc__"